import { render, staticRenderFns } from "./VeeCombobox.vue?vue&type=template&id=3fb2d360&"
import script from "./VeeCombobox.vue?vue&type=script&lang=js&"
export * from "./VeeCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports